import React from 'react';
import { IconButton } from '@material-ui/core';
import { EditIcon } from 'components/CustomSVG';
import useStyles from './styles';


const EditButton = ({handleClick}) => {
  const classes = useStyles();
  return (
    <IconButton
      className={classes.editIcon}
      onClick={handleClick}
      title="Edit"
    >
      <EditIcon stroke="#103a99" />
    </IconButton>
  );
};

export default EditButton;
